/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {TrainingCourse} from "../../model/TrainingCourse";
import {TrainingService} from "../../services/training.service";
import {NgxSpinnerService} from 'ngx-spinner';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-training',
    templateUrl: './training.component.html',
    styleUrls: ['./training.component.less'],
    standalone: false
})
export class TrainingComponent extends BaseMessageComponent implements OnInit {
  training: TrainingCourse[];
  indexWithChanges: number[] = [];

  constructor(private trainingService: TrainingService,
              private spinnerService: NgxSpinnerService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllTraining();
  }

  getAllTraining(): void {
    this.spinnerService.show();
    this.indexWithChanges = [];
    this.trainingService.getAllTraining().subscribe( value => {
        this.training = value;
        this.cdr.detectChanges();
      },
      err => {
        console.log(err);
        alert(err);
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  updateIndexes(index) {
    if(this.indexWithChanges.indexOf(index)===-1){
      this.indexWithChanges.push(index);
    }
    console.log(this.indexWithChanges);
  }

  addNew(newCourseNum: string, newCourseName: string) {
    if (newCourseNum.trim() == "" || newCourseName.trim() == "") {
      alert("Please add a course name and number before saving a new record.");
    } else {
      this.spinnerService.show();
      var newTraining = new TrainingCourse();
      newTraining.courseNumber = newCourseNum;
      newTraining.courseName = newCourseName;
      newTraining.active = true;

      this.trainingService.addNew(newTraining).subscribe(value => {
          //success
          this.training = null;
          this.getAllTraining();
        }, (error) => {
          //failed
          console.error(error);
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        });
    }
  }

  saveChanges() {
    if(this.indexWithChanges.length>0) {
      this.spinnerService.show();
      for (var i = 0; i < this.indexWithChanges.length; i++) {
        var idx = this.indexWithChanges[i];
        this.trainingService.updateTrainingCourse(this.training[idx]).subscribe(value => {
            console.log(this.training[idx] + " saved.")
          }, (error) => {
            //failed
            this.spinnerService.hide();
            console.error(error);
            if (error.status=='409')
              alert("Duplicate Value(s) found.");
            else
              alert(error.message);
          },
          () => {
            this.spinnerService.hide();
            this.indexWithChanges = [];
          });
      }
      setTimeout(() => {
        this.getAllTraining();
      }, 4000);
    } else {
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }
}
